import moment from "moment"
import { RemoveAccents } from "../../../../../utils"

export const getObjFilters = (
  filterState: any,
  pageNum: number,
  pageSize: number,
  productCode: string
) => {
  let dataFilters: any = {
    pageNum: pageNum,
    pageSize: pageSize,
    filter: [
      {
        FieldName: 'InsuranceMarkets',
        Comparision: '==',
        FieldValue: '2',
      },
      {fieldName: 'ProductCode', comparision: '==', fieldValue: productCode},
    ],
  }
  if (filterState.branchCode && filterState.branchCode != '0') {
    let object = {
      FieldName: 'DivisionCode',
      Comparision: '==',
      FieldValue: filterState.branchCode,
    }
    dataFilters.filter.push(object)
  }
  if (filterState.fromDate) {
    let object = {
      FieldName: 'FromDate',
      Comparision: '>=',
      FieldValue: moment(filterState.fromDate, 'YYYY/MM/DD').format('DD/MM/YYYY'),
    }
    dataFilters.filter.push(object)
  }
  if (filterState.toDate) {
    let object = {
      FieldName: 'ToDate',
      Comparision: '<=',
      FieldValue: moment(filterState.toDate, 'YYYY/MM/DD').format('DD/MM/YYYY'),
    }
    dataFilters.filter.push(object)
  }
  if (filterState.partnerCode && filterState.partnerCode != '0') {
    let object = {
      FieldName: 'PartnerCode',
      Comparision: '==',
      FieldValue: filterState.partnerCode,
    }
    dataFilters.filter.push(object)
  }
  if (filterState.userCode) {
    let object = {
      FieldName: 'Manager',
      Comparision: '==',
      FieldValue: filterState.userCode,
    }
    dataFilters.filter.push(object)
  }
  if (filterState.source && filterState.source != '0') {
    let object = {
      FieldName: 'Source',
      Comparision: '==',
      FieldValue: filterState.source,
    }
    dataFilters.filter.push(object)
  }
  if (filterState.contractNo) {
    let object = {
      FieldName: 'ContractNumber',
      Comparision: 'Contains',
      FieldValue: filterState.contractNo,
    }
    dataFilters.filter.push(object)
  }
  if (filterState.customerName) {
    let object = {
      FieldName: 'Filter',
      Comparision: 'Contains',
      FieldValue: RemoveAccents(filterState.customerName),
    }
    dataFilters.filter.push(object)
  }
  if (filterState.contractKind) {
    let object = {
      FieldName: 'ContractKind',
      Comparision: '=',
      FieldValue: filterState.contractKind,
    }
    dataFilters.filter.push(object)
  }
  if (filterState.contractStatus) {
    let object = {
      FieldName: 'ContractStatusType',
      Comparision: '==',
      FieldValue: filterState.contractStatus,
    }

    dataFilters.filter.push(object)
  }
  return dataFilters
}
